/**
 * Water Log Firestore Service
 * Collection: babies/{babyId}/waterLogs
 * Tracks water intake (ml) during the solids phase.
 */

import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  orderBy,
  Timestamp,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import type { WaterLog } from '../types';

function waterLogsCol(babyId: string) {
  return collection(db, 'babies', babyId, 'waterLogs');
}

/** Save a water log entry */
export async function addWaterLog(
  babyId: string,
  amountMl: number
): Promise<WaterLog> {
  const now = new Date();
  const date = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  const ref = await addDoc(waterLogsCol(babyId), {
    date,
    amountMl,
    timestamp: Timestamp.fromDate(now),
    createdAt: serverTimestamp(),
  });
  return { id: ref.id, date, amountMl, timestamp: now };
}

/** Fetch today's water logs and return total ml */
export async function getWaterTodayMl(babyId: string): Promise<number> {
  const now = new Date();
  const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  const snap = await getDocs(
    query(waterLogsCol(babyId), where('date', '==', dateStr), orderBy('timestamp', 'asc'))
  );
  return snap.docs.reduce((sum, d) => sum + (d.data().amountMl as number), 0);
}
